import boats from './Boats'
import engines from './Engines'
import users from './Users'
import devices from './Devices'
import dealerIndex from './Dealers/dealerIndex'
import signals from './Signals'

export const Boats = boats
export const Engines = engines
export const Users = users
export const Devices = devices
export const Dealers = dealerIndex
export const Signals = signals
